/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {NgProgressRouter as ɵa} from './ng-progress-router.service';